export const loginModal = {
  invoke: {
    src: 'watchLoginModalActions',
    cond: 'isHeaderInVisibleMode',
  },
  on: {
    LOGIN_MODAL_STATE_AWAIT_LOGIN: {
      actions: [
        {
          type: 'save',
          data: {
            loginModalState: {
              isAwaitingLogin: true,
            },
          },
        },
      ],
    },
    SESSION_STATE_LOGGED_IN: {
      actions: [
        {
          type: 'save',
          data: {
            loginModalState: {
              isAwaitingLogin: false,
            },
          },
        },
      ],
    },
    SESSION_STATE_LOGGED_OUT: {
      actions: [
        {
          type: 'save',
          data: {
            isAccountInfoAvailable: false,
          },
        },
      ],
    },
  },
};
